<template>
  <div class="tw-w-full tw-flex tw-justify-end tw-gap-2 tw-px-4">
    <a-action-button
      as="router-link"
      :to="{ name: 'pages.admin.videos.show', params: { id: props.item.id } }"
      icon="solar:eye-bold-duotone"
      intent="simple"
      :title="i18n.t('common.view', 'View')"
    />
    <a-action-button
      as="router-link"
      :to="{ name: 'pages.admin.videos.edit', params: { id: props.item.id } }"
      icon="solar:pen-bold-duotone"
      intent="simple"
      :title="i18n.t('common.edit', 'Edit')"
    />
    <a-action-button
      @click="visible.delete = true"
      icon="solar:trash-bin-2-bold-duotone"
      intent="danger"
      :title="i18n.t('common.delete', 'Delete')"
    />

    <delete-modal
      :visible="visible.delete"
      :loading="loading.delete"
      @confirm="onDeleteConfirmed"
      @cancel="visible.delete = false"
    />
  </div>
</template>

<script setup>
import { defineProps, ref, inject } from 'vue';
import { useI18n } from 'vue-i18n';
import videosApi from '@/api/videos';
import useAlert from '@/composables/useAlert';
import DeleteModal from '@/components/modals/DeleteModal';

const i18n = useI18n();

const props = defineProps({
    item: { type: Object, required: true }
});

const visible = ref({ delete: false });
const loading = ref({ delete: false });
const onDeleted = inject('onDeleted');

const onDeleteConfirmed = async () => {
    loading.value.delete = true;
    try {
        const r = await videosApi.admin.destroy(props.item.id);
        if (r.data.code === 'SUCCESS' || r.status === 200) {
            useAlert(i18n.t('videos.deleted', 'Video deleted'), 'success');
            if (onDeleted) onDeleted(props.item.id);
            visible.value.delete = false;
        }
    } catch (error) {
        console.error('Error deleting video:', error);
        useAlert(i18n.t('errors.something-went-wrong', 'Something went wrong'), 'danger');
    } finally {
        loading.value.delete = false;
    }
};
</script>

<style></style>
